import {
  EnhancedLabeledSelectControl,
  EnhancedLabeledSelectProps,
  useEnhancedLabeledSelectOverrides,
} from '@gorila-shared-ui/components';
import { Select } from 'baseui/select';

export function EnhancedLabeledSelect({
  value,
  onChange,
  options,
  label,
  searchable = false,
  disabled = false,
  labelKey,
  valueKey,
  fullWidth = false,
  infiniteScroll = false,
  fetchDataLoading = false,
  hasNext = false,
  isMulti = false,
  inset = false,
  fetchData,
  onInputChange,
  filterOptions,
  onBlur,
  clearable = false,
  placeholder,
  selectMaxWidth,
  inline = false,
  maxWidth,
  required = false,
  error,
  caption,
  maxDropdownHeight = '150px',
  smallContainer = false,
  dropdownOffset,
  onBlurResetsInput = false,
}: Readonly<EnhancedLabeledSelectProps>) {
  const overrides = useEnhancedLabeledSelectOverrides({
    dropdownOffset,
    fetchData,
    fullWidth,
    hasNext,
    infiniteScroll,
    inline,
    inset,
    label,
    maxDropdownHeight,
    selectMaxWidth,
    smallContainer,
  });

  return (
    <EnhancedLabeledSelectControl
      caption={caption}
      disabled={disabled}
      error={error}
      inline={inline}
      inset={inset}
      label={label}
      maxWidth={maxWidth}
      required={required}
    >
      <Select
        onBlur={onBlur}
        closeOnSelect
        openOnClick
        clearable={clearable}
        onChange={onChange}
        options={options}
        searchable={searchable}
        size={'compact'}
        value={value}
        disabled={disabled}
        labelKey={labelKey}
        valueKey={valueKey}
        onInputChange={onInputChange}
        filterOptions={filterOptions}
        isLoading={fetchDataLoading}
        multi={isMulti}
        maxDropdownHeight={maxDropdownHeight}
        placeholder={placeholder}
        onBlurResetsInput={onBlurResetsInput}
        overrides={overrides}
      />
    </EnhancedLabeledSelectControl>
  );
}
